import { useEffect, useMemo, useState } from 'react';
import { getLocale, loadLocale, type Languages, type TransactionType } from '../locales';
import { useAppearance } from './useAppearance';

export default function useLocales() {
  const { appearance } = useAppearance();

  const language: Languages = useMemo(() => {
    return appearance?.language ?? 'en-US';
  }, [appearance.language]);

  const overrideLocales = useMemo(() => {
    return appearance.overrideLocales;
  }, [appearance.overrideLocales]);

  const [loadedLocale, setLoadedLocale] = useState<TransactionType>(() => getLocale(language));

  useEffect(() => {
    let cancelled = false;
    loadLocale(language).then((locale) => {
      if (!cancelled) setLoadedLocale(locale);
    });
    return () => {
      cancelled = true;
    };
  }, [language]);

  const translations: TransactionType = useMemo(() => {
    const overrideLanguage = overrideLocales?.[language];
    return { ...loadedLocale, ...overrideLanguage };
  }, [loadedLocale, language, overrideLocales]);

  if (!translations) {
    throw new Error(`Missing translations for ${language}`);
  }

  return translations;
}
